import React from "react";
import menuImg from "../../../resources/images/app/header/menu.png";


export default function NavigationMenuMobilePopupButton({onClick}) {

    return (
        <div className="mobile-menu-icon" onClick={onClick}>
            <img src={menuImg} alt=""/>
        </div>
    )
}
